import { Link, useParams } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import { FaPlus, FaUserCog } from 'react-icons/fa';
import { Outlet, useMatch, useResolvedPath } from 'react-router-dom';
import BackButton from '../../../../Components/BackButton';
import { useSelector } from 'react-redux';
import { checkPermission } from '../../../../_helpers/roles/check-roles';

function Executive() {
  const intl = useIntl();
  let resolved = useResolvedPath('new');
  let isForm = useMatch({ path: resolved.pathname, end: true });
  const user = useSelector((state) => state.user.user);
  const { edit: isEdit } = useParams();
  return (
    <div className="card content-section">
      <div className="card-header ">
        <div className="mx-2 mt-4">
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <h4 className="d-inline-block text-primary">
                <FaUserCog className="me-2" />
                {isEdit
                  ? intl.formatMessage({ id: 'edit' })
                  : isForm
                  ? intl.formatMessage({ id: 'new' })
                  : ''}
                &nbsp;
                <FormattedMessage id="executives" />
              </h4>
              <BackButton variant="secondary" style={'mx-3'} />
            </div>

            {!isForm && checkPermission(user?.active_role, 'Can add executive') && !isEdit && (
              <div className="d-flex justify-content-between align-items-end">
                <Link to="new" className="text-light">
                  <Button variant="primary">
                    <FaPlus size={18} />

                    <FormattedMessage id="add_new" />
                  </Button>
                </Link>
              </div>
            )}
          </div>
          <hr />
        </div>
      </div>
      <div className="card-body">
        <Outlet />
      </div>
    </div>
  );
}

export default Executive;
